export const LOW_HIT = 2
export const MID_HIT = 2.5
export const HIG_HIT = 3